import React, { useEffect, useRef } from 'react';

// Creates audio tones using Web Audio API - no external files needed!
const createTone = (ctx, freq, duration, type = 'sine', gain = 0.3) => {
  const osc = ctx.createOscillator();
  const gainNode = ctx.createGain();
  osc.connect(gainNode);
  gainNode.connect(ctx.destination);
  osc.type = type;
  osc.frequency.setValueAtTime(freq, ctx.currentTime);
  gainNode.gain.setValueAtTime(gain, ctx.currentTime);
  gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
  osc.start(ctx.currentTime);
  osc.stop(ctx.currentTime + duration);
};

// Success melody - ascending happy notes
export const playSuccess = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    createTone(ctx, 523, 0.15); // C5
    setTimeout(() => createTone(ctx, 659, 0.15), 150); // E5
    setTimeout(() => createTone(ctx, 784, 0.15), 300); // G5
    setTimeout(() => createTone(ctx, 1047, 0.3), 450); // C6
  } catch {}
};

// Milestone melody - triumphant fanfare
export const playMilestone = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [523, 659, 784, 659, 784, 1047].forEach((freq, i) => {
      setTimeout(() => createTone(ctx, freq, 0.2, 'triangle', 0.4), i * 120);
    });
  } catch {}
};

// Gentle reminder bell
export const playReminder = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    createTone(ctx, 880, 0.5, 'sine', 0.2);
    setTimeout(() => createTone(ctx, 1100, 0.5, 'sine', 0.15), 600);
  } catch {}
};

// Vibration patterns
export const vibrateSuccess = () => {
  if (navigator.vibrate) navigator.vibrate([100, 50, 100, 50, 200]);
};

export const vibrateMilestone = () => {
  if (navigator.vibrate) navigator.vibrate([200, 100, 200, 100, 400]);
};

// Hook for auto-play on check-in
export const useSoundFeedback = () => {
  const playCheckIn = () => {
    playSuccess();
    vibrateSuccess();
  };

  const playAchievement = () => {
    playMilestone();
    vibrateMilestone();
  };

  return { playCheckIn, playAchievement };
};

export default { playSuccess, playMilestone, playReminder };
